<template>
  <div
    style="width:100%;height:100%"
    class="chart-class"
    ref="teachersAward"
  ></div>
</template>

<script>
export default {
  props: {
    trainingList: "",
  },
  data() {
    return {
    };
  },
  mounted() {
    this.initCharts();
  },
  computed: {
    nameList() {
      return this.trainingList.map((item) => item.trainingType1Desc);
    },
    scoreList() {
      return this.trainingList.map((item) => item.score);
    },
  },
  methods: {
    initCharts() {
      let data = {
        xData: this.nameList,
        yData: this.scoreList,
      };

      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          top: "80",
          left: "3%",
          right: "4%",
          bottom: "0%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            axisTick: {
              show: false,
            },
            data: data.xData,
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
              formatter: "{value}",
            },
            splitLine: {
              show: false,
            },
          },
        ],
        series: [
          {
            type: "bar",
            barWidth: "15%",
            label: {
              show: true,
              position: "top",
              textStyle: {
                color: "#000000",
              },
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  var colorListr = ["#36CB8C", "#36CB8C"];
                  return colorListr[params.dataIndex];
                },
                label: {
                  show: true,
                  position: "top",
                  formatter: "{c}分",
                  fontSize: 17,
                },
                shadowBlur: 10,
                shadowColor: "rgba(40, 40, 40, 0.3)",
              },
            },
            data: data.yData,
          },
        ],
      };

      let myChart = this.$echarts.init(this.$refs.teachersAward);
      myChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
</style>
